import React from "react"

const MediaWrapper = ({ children, background = "false", wide = "false" }) => {
  return (
    <div
      className={`media-wrapper ${
        background.toLowerCase() === "true" ? "media-wrapper--background" : ""
      } ${wide.toLowerCase() === "true" ? "media-wrapper--wide" : ""}`}
    >
      {children}
    </div>
  )
}

export default MediaWrapper
